import {
  Autocomplete,
  Button,
  Chip,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import StaffSelector from '../../../events/StaffSelector'
import EmployeeSelector from '../../../events/EmployeeSelector'

const EditAccess = ({ loadList, onClose }) => {
  const options = ['Viewer', 'Call Taker', 'Dispatcher', 'Commander']
  const [selectedStaff, setSelectedStaff] = useState(null)
  const [selectedAccess, setSelectedAccess] = useState('')

  useEffect(() => {
    if (selectedStaff?.cadAccess) {
      setSelectedAccess(selectedStaff.cadAccess)
    }
  }, [selectedStaff])

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/edit-employee-cad-permissions', {
      employee: selectedStaff.employee._id,
      selectedAccess,
    }).then((res) => {
      if (res.status === 200) {
        onClose()
        loadList()
      }
    })
  }

  return (
    <Stack gap={1} component="form" onSubmit={handleSubmit}>
      <Typography variant="title3">Edit CAD Access Permissions</Typography>
      <EmployeeSelector
        value={selectedStaff}
        onChange={(e, newValue) => setSelectedStaff(newValue)}
        label="Staff Member"
        helperText="Select a member of staff to update their CAD permissions"
        required
      />
      <Autocomplete
        value={selectedAccess}
        options={options}
        onChange={(e, newValue) => {
          setSelectedAccess(newValue)
        }}
        renderInput={(params) => <TextField {...params} label="Access Role" />}
      />
      <Button variant="contained" fullWidth color="anGreen" type="submit">
        Submit
      </Button>
    </Stack>
  )
}

export default EditAccess
